import { useTranslation } from 'react-i18next';
import { trpc } from '@org/clients/school';
import { type ChartSeries } from '@org/ui';
import { useAnalytics } from '../analytics-context';
import { ReportCard } from '../report-card';
import { ReportTable } from '../report-table';
import { TimeSeriesCard } from '../time-series-card';
import { formatRate } from '../format';

export function JourneyReports() {
  const { t } = useTranslation('admin');
  const { input, compareInput } = useAnalytics();
  const overTime = trpc.analytics.journey.unitsOverTime.useQuery(input);
  const cmpOverTime = trpc.analytics.journey.unitsOverTime.useQuery(compareInput ?? input, { enabled: Boolean(compareInput) });
  const byUnit = trpc.analytics.journey.byUnit.useQuery(input);

  const series: ChartSeries[] = [
    { key: 'started', label: t('analytics.journey.overTime.series.started') },
    { key: 'completed', label: t('analytics.journey.overTime.series.completed') },
    { key: 'badges', label: t('analytics.journey.overTime.series.badges') },
  ];

  return (
    <div className="space-y-6">
      <TimeSeriesCard
        title={t('analytics.journey.overTime.title')}
        description={t('analytics.journey.overTime.description')}
        data={overTime.data}
        cmpData={cmpOverTime.data}
        series={series}
        isLoading={overTime.isLoading}
        error={overTime.error}
      />

      <ReportCard
        title={t('analytics.journey.byUnit.title')}
        description={t('analytics.journey.byUnit.description')}
        isLoading={byUnit.isLoading}
        error={byUnit.error}
        isEmpty={byUnit.data?.length === 0}
      >
        <ReportTable
          rows={byUnit.data ?? []}
          rowKey={(r) => r.unitId}
          defaultSort="completed"
          searchKeys={['unit', 'journey']}
          columns={[
            { key: 'unit', label: t('analytics.journey.byUnit.unit'), value: (r) => r.unitName, className: 'font-medium' },
            { key: 'journey', label: t('analytics.journey.byUnit.journey'), value: (r) => r.journeyName, className: 'text-muted-foreground' },
            { key: 'inProgress', label: t('analytics.journey.byUnit.inProgress'), value: (r) => r.inProgress, align: 'right' },
            { key: 'completed', label: t('analytics.journey.byUnit.completed'), value: (r) => r.completed, align: 'right' },
            { key: 'badges', label: t('analytics.journey.byUnit.badges'), value: (r) => r.badges, align: 'right' },
            { key: 'badgeRate', label: t('analytics.journey.byUnit.badgeRate'), value: (r) => r.badgeRate, render: (r) => formatRate(r.badgeRate), align: 'right' },
            { key: 'stories', label: t('analytics.journey.byUnit.storiesSeen'), value: (r) => r.storiesSeen, align: 'right' },
          ]}
        />
      </ReportCard>
    </div>
  );
}
